import React, { useState } from "react";
import "../../assets/style/FAQ.css"
import { useTranslation } from "react-i18next";

function FAQ() {
  const { t } = useTranslation();
  const data = [
    {
      question: t("aiq1"),
      answer:
        t("aia1"),
    },
    {
      question: t("aiq2"),
      answer:
        t("aia2"),
    },
    {
      question: t("aiq3"),
      answer:
        t("aia3"),
    },
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
  <div className="faq-container">
    <h2 className="faq-title">FAQ</h2>
    <div className="space-y-4">
      {data.map((item, index) => (
        <div
          key={index}
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
        >
          <button
            onClick={() => toggleFAQ(index)}
            className="faq-question"
          >
            <span>{item.question}</span>
            <span>{activeIndex === index ? "−" : "+"}</span>
          </button>
          {activeIndex === index && (
            <div className="faq-answer">
              {item.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
</section>
  );
};

export default FAQ;
